import { useEffect, useState } from "react";
import { api, STATUS_COLORS } from "../api";
import { useLang } from "../i18n";
import { Badge } from "../components/ui/badge";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../components/ui/table";
import { Card, CardContent } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Eye } from "lucide-react";
import { toast } from "sonner";

export default function AdminTenants() {
  const { lang } = useLang();
  const bm = lang === "bm";
  const [tenants, setTenants] = useState([]);

  const load = () => api.get("/admin/tenants").then((r) => setTenants(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const update = async (tenantId, field, value) => {
    try {
      await api.patch(`/admin/tenants/${tenantId}`, { [field]: value });
      toast.success("Updated");
      load();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Error");
    }
  };

  return (
    <div data-testid="admin-tenants-page" className="space-y-6">
      <h1 className="text-2xl sm:text-3xl font-bold tracking-tight">{bm ? "Admin Platform — Tenants" : "Platform Admin — Tenants"}</h1>
      <Card>
        <CardContent className="pt-4 overflow-x-auto">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>{bm ? "Syarikat" : "Company"}</TableHead>
                <TableHead>{bm ? "Pekerja" : "Employees"}</TableHead>
                <TableHead>Users</TableHead>
                <TableHead>Plan</TableHead>
                <TableHead>Status</TableHead>
                <TableHead className="hidden md:table-cell">Subdomain</TableHead>
                <TableHead className="text-right">{bm ? "Tindakan" : "Actions"}</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {tenants.map((t) => (
                <TableRow key={t.tenant_id} data-testid={`tenant-row-${t.tenant_id}`}>
                  <TableCell>
                    <div className="flex items-center gap-2">
                      <div className="w-7 h-7 rounded-md flex items-center justify-center text-white text-xs font-bold" style={{ backgroundColor: t.branding?.primary_color || "#1E40AF" }}>
                        {t.company_name[0]}
                      </div>
                      <span className="text-sm font-medium">{t.company_name}</span>
                    </div>
                  </TableCell>
                  <TableCell className="font-mono text-sm">{t.headcount}</TableCell>
                  <TableCell className="font-mono text-sm">{t.users}</TableCell>
                  <TableCell>
                    <Select value={t.plan} onValueChange={(v) => update(t.tenant_id, "plan", v)}>
                      <SelectTrigger data-testid={`tenant-plan-${t.tenant_id}`} className="w-36 h-8 text-xs"><SelectValue /></SelectTrigger>
                      <SelectContent>
                        {["STARTER", "PROFESSIONAL", "BUSINESS", "ENTERPRISE"].map((p) => <SelectItem key={p} value={p}>{p}</SelectItem>)}
                      </SelectContent>
                    </Select>
                  </TableCell>
                  <TableCell>
                    <Select value={t.status} onValueChange={(v) => update(t.tenant_id, "status", v)}>
                      <SelectTrigger data-testid={`tenant-status-${t.tenant_id}`} className="w-32 h-8 text-xs"><SelectValue /></SelectTrigger>
                      <SelectContent>
                        {["TRIAL", "ACTIVE", "SUSPENDED", "CANCELLED"].map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}
                      </SelectContent>
                    </Select>
                  </TableCell>
                  <TableCell className="hidden md:table-cell text-sm font-mono">{t.branding?.subdomain ? `${t.branding.subdomain}.hrplatform.com` : "-"}</TableCell>
                  <TableCell className="text-right">
                    <Button data-testid={`view-tenant-${t.tenant_id}`} size="sm" variant="outline"
                      onClick={() => {
                        sessionStorage.setItem("view_tenant", t.tenant_id);
                        sessionStorage.setItem("view_tenant_name", t.company_name);
                        window.location.href = "/dashboard";
                      }}>
                      <Eye className="w-4 h-4 mr-1" /> {bm ? "Lihat" : "View"}
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
}
